import { AiFillMinusCircle, AiFillCheckCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

export function StepBar(props) {
  const navigate = useNavigate();

  const navigateToStep = (step) => {
    if (step.status === "current") {
      return;
    }
    switch (step.label) {
      case "Profile":
        navigate("/set-profile");
        break;
      case "Wallet":
        navigate("/set-wallet");
        break;
      case "Team":
        navigate("/set-team");
        break;
      case "Plan":
        navigate("/set-plan");
        break;
      default:
        break;
    }
  };

  const RenderStep = (step, index) => {
    if (step.status === "complete") {
      return (
        <li className="relative text-center text-gray-400" key={index}>
          <button onClick={() => navigateToStep(step)}>
            <span className="absolute left-1/2 -bottom-[1.75rem] -translate-x-1/2 rounded-full bg-gray-400 text-gray-300">
              <AiFillCheckCircle size={20} />
            </span>

            <span className="hidden sm:block">{step.label}</span>

            <svg
              className="ml-0 h-6 w-6 sm:hidden"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
              />
            </svg>
          </button>
        </li>
      );
    } else if (step.status === "current") {
      return (
        <li className="relative text-center text-indigo-500" key={index}>
          <button onClick={() => navigateToStep(step)}>
            <span className="absolute left-1/2 -bottom-[1.75rem] -translate-x-1/2 rounded-full bg-gray-400 text-gray-300">
              <AiFillMinusCircle size={20} />
            </span>

            <span className="hidden sm:block"> {step.label} </span>

            <svg
              className="ml-0 h-6 w-6 sm:hidden"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
              />
            </svg>
          </button>
        </li>
      );
    } else if (step.status === "incomplete") {
      return (
        <li className="relative text-center text-gray-400" key={index}>
          <button onClick={() => navigateToStep(step)}>
            <span className="absolute left-1/2 -bottom-[1.75rem] -translate-x-1/2 rounded-full bg-gray-400 text-gray-300">
              <AiFillMinusCircle size={20} />
            </span>
            <span className="hidden sm:block"> {step.label} </span>
          </button>
        </li>
      );
    }
  };

  return (
    <div className="mb-4">
      <h2 className="sr-only">Steps</h2>

      <div className="after:mt-4 after:block after:h-1 after:w-full after:rounded-lg after:bg-gray-200">
        <ol className={`grid grid-cols-4 text-sm font-medium text-gray-500`}>
          {props.steps.map((step, index) => {
            return RenderStep(step, index);
          })}
        </ol>
      </div>
    </div>
  );
}
